import { render, staticRenderFns } from "./LbsModal1.vue?vue&type=template&id=3be230c6&"
var script = {}
import style0 from "./LbsModal1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports